module.exports = __webpack_public_path__ + "files/ff78488db9b5134f3c70d3f472687401.png";